define.alias("shared/components/shared/post/secondary/caption-writer/disclaimer", "calendar/components/shared/post/secondary/caption-writer/disclaimer");